import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import AksharTransliteration from './AksharTransliteration'
import AksharProjectSettings from './AksharApiKeys';
import AksharReportTab from './reports/AksharReportTab';

import $ from 'jquery';
import AksharTestTab from './AksharTestTab';

class AksharLeftPanel extends Component {

  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = ['/api-keys'];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/cloud-akshar/";
      var path1 = window.origin + "/platform/cloud-akshar";
      if (currentPath == path || currentPath == path1 || projectSettingsPathExist) {
        $("#left-panel-menu-projectSettings").addClass('activemenu');
      } else if (currentPath.includes('/test')) {
        $("#left-panel-menu-test").addClass('activemenu');
      } else if (currentPath.includes('/reports')) {
        $("#left-panel-menu-cloud-akshar-reports").addClass('activemenu');
      }
      $("#left-panel-menu-projectSettings,#left-panel-menu-test,#left-panel-menu-cloud-akshar-reports")
        .on("click", function () {
          $("#left-panel-menu-projectSettings,#left-panel-menu-test,#left-panel-menu-cloud-akshar-reports")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

        })

    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div className="left-menu" style={{ marginTop: '0px', position: "absolute" }} >
              <ul id="floatMenu">
                <Link to="/cloud-akshar">
                  <li id="left-panel-menu-projectSettings" className="tabs">
                    <i className="fa flaticon-ui" /><span>Transliteration API Settings</span>
                  </li>
                </Link>
                <Link to="/cloud-akshar/test-and-deploy">
                  <li id="left-panel-menu-test" className="tabs">
                    <i className="fa flaticon-ui" /><span>Test & Deploy</span>
                  </li>
                </Link>
                <Link to="/cloud-akshar/reports">
                  <li id="left-panel-menu-cloud-akshar-reports" className="tabs">
                    <i className="fa flaticon-ui" /><span>Report</span>
                  </li></Link>
              </ul>
            </div>
          </div>
          <Switch>
            <Route path='/cloud-akshar/invoice-and-pricing' ></Route>
            <Route path="/cloud-akshar/reports" component={AksharReportTab}></Route>
            <Route path="/cloud-akshar/test-and-deploy" component={AksharTestTab}></Route>
            <Route path="/cloud-akshar" component={AksharProjectSettings}></Route>
          </Switch>
        </div>
      </Router>
    );
  }
}
export default AksharLeftPanel;



// WEBPACK FOOTER //
// ./src/aksharUi/AksharLeftPanel.js